import { useState, useEffect } from "react";

import DefaultContainer from "../../../components/DefaultContainer";
import { Grid, List, ListItem, Typography, Fade, Switch, FormControl, FormControlLabel } from "@mui/material";
import { Form, Field } from "react-final-form";
import { ParentalConsentType } from "../../../__generated__/graphql";
import { LoadingButton } from "@mui/lab";
import { useManageModal } from "../../Manage/components/ManageModal";
import { ParentalConsentConfirmModal, ParentalConsentConfirmProps } from "./ParentalConsentConfirmModal";

type StudentConsentDetails = {
    studentName?: string,
    studentId?: string,
    timelapseWindow?: string,
    consentStatus?: string | null,
    code?: ErrorMessageCodeType,
    localRun: boolean
}
const ParentalConsent = () => {
    const { openModal } = useManageModal();
    const [openParentModal, setOpenModal] = useState<boolean>(false)
    //TO PROMPT A NEW PAGE
    const [submitted, setSubmitted] = useState<boolean>(false)
    //THIS IS FOR THE ACTIVE PART OF THE LOADING BUTTON IN MODAL
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [consentStatus, setConsentStatus] = useState<ParentalConsentType | null>(null);
    const [studentDetails, setStudentDetails] = useState<StudentConsentDetails>({
        studentName: '',
        studentId: '',
        timelapseWindow: '',
        consentStatus: null,
        code: null,
        localRun: false,
    })
    useEffect(() => {
        async function getStudentDetails() {
            const request = await fetch(`${window.__env?.API_URL}/api/parent/consent/details`, { credentials: 'include' })
            const json = request.status === 403 ?
                {
                    studentName: '',
                    code: "NOT_AUTHORIZED"
                } : await request.json()
            if (request.ok) {
                setStudentDetails({
                    studentName: json.studentName,
                    studentId: json.studentId,
                    timelapseWindow: json.timelapseWindow,
                    consentStatus: json.consentStatus,
                    code: null,
                    localRun: json.localRun,
                    // screenType:"something"
                })
                return;
            }
            setStudentDetails({
                studentName: '',
                studentId: '',
                timelapseWindow: '',
                consentStatus: '',
                code: json.code,
                localRun: false
            })
        }
        getStudentDetails();
    }, [])

    const onSubmit = async (values: any) => {
        setSubmitting(true)
        var response = await fetch(`${window.__env.API_URL}/api/parent/consent/${studentDetails.studentId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",

            },
            body: JSON.stringify({
                consentResp: values,
                localRun: studentDetails.localRun
            })
        }
        )
        if (response.status >= 500) {
            openModal({ type: "PARENTAL_CONSENT_ERROR", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })

        }
        if (response.status >= 200) {
            openModal({ type: "PARENTAL_CONSENT_SUCCESS", eventType: "DISABLE_BACKDROP", cancelButtonLabel: "Close" })
            setSubmitted(true)
        }
        setSubmitting(false)

    }
    const doubleCheck = async (values: any) => {
        const parsedValue = values.agree ? ParentalConsentType.Given : ParentalConsentType.Rejected;
        setConsentStatus(parsedValue);
        setOpenModal(true)
    }
    useEffect(() => {
        console.log("the details: ", studentDetails)
    }, [studentDetails])
    if (submitted) {
        return (
            <FormAlreadyCompleted type={"JUST_SUBMITTED"} />
        )
    }
    if ((studentDetails.consentStatus === "Given" || studentDetails.consentStatus === "Timelapsed" || studentDetails.consentStatus === "Rejected")) {
        return (
            <FormAlreadyCompleted type={"DONE_ALREADY"} />
        )
    }
    if (studentDetails.code) {
        return (
            <ErrorComponent code={studentDetails.code} />
        )
    }
    const getDivHeight = () => {
        if (window.innerWidth < 600) return "auto"
        return "100vh"
    }
    return (
        <Fade appear in={true} timeout={400}>
            <div id="this id" style={{
                display: "flex", justifyContent: "center", alignItems: "center",
                // height: getDivHeight()
            }}>
                <DefaultContainer style={{
                    backgroundSize: "cover", backgroundPosition: "center",
                    height: "fit-content",
                    width: "2000px",
                    margin: ".5rem"
                }}>
                    <Grid container spacing={1} sx={{ padding: ".5rem" }}>
                        <Grid size={12} style={{ marginTop: "2px", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
                            <div style={{
                                width: "200px", height: "100px", objectFit: "cover", background: `url(${process.env.PUBLIC_URL}/assets/images/logos/FT_logo_1.png)`,
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                            }}></div>
                        </Grid>
                        <Grid size={12} style={{ padding: "0 .5rem" }}>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Typography sx={{ fontSize: "14px" }}>As part of our ongoing wellness support, we are introducing the use of futuresTHRIVE™
                                        tScreen/TweenScreen, to monitor our students. The purpose of tScreen/TweenScreen is to create a safe,
                                        user-friendly environment where students feel encouraged to be open about their feelings. The
                                        goal is to gain a deeper understanding of your child’s mental health.</Typography>
                                </Grid>
                                <Grid size={12}>
                                    <Typography sx={{ fontSize: "14px" }}>
                                        futuresTHRIVE (fT) has utilized the latest scientific research to develop a HIPAA-compliant
                                        survey. This survey provides insights through
                                        evidence-based scales and individual feedback in a visually engaging format.
                                    </Typography>
                                </Grid>
                                <Grid size={12}> <Typography sx={{ fontSize: "14px" }}>futuresTHRIVE tScreen/TweenScreen includes research from reputable sources such as the
                                    American Academy of Pediatrics, the American Academy of Psychiatry, JAMA, the Centers for
                                    Disease Control, and the World Health Organization. The fT team is made up of doctors and
                                    stakeholders committed to addressing mental health.
                                </Typography></Grid>
                                <Grid size={12}>
                                    <List sx={{ fontSize: "14px" }}>
                                        <Typography sx={{ fontSize: "14px" }}>Key details about TweenScreen:</Typography>
                                        <Grid container spacing={.5}>
                                            <Grid size={6}><ListItem sx={{ display: "list-item", listStyle: "disc", pl: 2, listStylePosition: "inside" }}>
                                                Backed by the latest scientific evidence
                                            </ListItem></Grid>
                                            <Grid size={6}>  <ListItem sx={{ display: "list-item", listStyle: "disc", pl: 2, listStylePosition: "inside" }}>
                                                Suitable for ages 5-9 (tScreen™) and 9-16 (TweenScreen™)
                                            </ListItem></Grid>
                                            <Grid size={6}><ListItem sx={{ display: "list-item", listStyle: "disc", pl: 2, listStylePosition: "inside" }}>
                                                Monitors signs and symptoms of Adverse Childhood Experiences®, Positive Childhood
                                                Experiences®, relationships, routines, and school/home functioning
                                            </ListItem>
                                            </Grid>
                                            <Grid size={6}>
                                                <ListItem sx={{ display: "list-item", listStyle: "disc", pl: 2, listStylePosition: "inside" }}>
                                                    Assesses ADHD, Anxiety, Depression and Suicidality
                                                </ListItem>
                                            </Grid>
                                        </Grid>
                                    </List>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Typography>TweenScreen Walkthrough</Typography>
                                    <video width="320" height="180" controls>
                                        <source src={`${process.env.PUBLIC_URL}/assets/videos/TweenScreen.mp4`} type="video/mp4" />
                                    </video>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Typography>tScreen Walkthrough</Typography>
                                    <video width="320" height="180" controls>
                                        <source src={`${process.env.PUBLIC_URL}/assets/videos/TScreen.mp4`} type="video/mp4" />
                                    </video>
                                </Grid>
                                <Grid size={12} sx={{ paddingTop: ".5rem" }}>
                                    {studentDetails.timelapseWindow != null ?
                                        <Typography sx={{ fontSize: "14px" }}>In accordance with State, Company, School and/or local policy we need your consent to help your consent to help your child. However, if you do not respond in <strong>{studentDetails.timelapseWindow}</strong> days, your consent will be given automatically, as per your state, company, school and/or local policy. </Typography>
                                        : <Typography sx={{ fontSize: "14px" }}>In accordance with State, Company, School or local policy we need your consent to help your consent to help your child.</Typography>}
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid size={12} sx={{ padding: ".5rem" }}>
                            <Form style={{ padding: "0 .5rem" }}
                                initialValues={{}}
                                onSubmit={doubleCheck}
                                render={({ form, submitting, handleSubmit, values }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid container style={{ marginTop: 0 }}>
                                            <Grid size={12}>
                                                <Field name="agree" type="checkbox">
                                                    {({ input }) => (
                                                        <FormControlLabel control={<Switch
                                                            value={input.value}
                                                            onChange={(e) => input.onChange(e.target.checked)}
                                                        />} label={
                                                            <Typography><strong>I consent to my child's ({studentDetails.studentName}) participation in the futuresTHRIVE tScreen/TweenScreen*</strong></Typography>
                                                        } />
                                                    )}
                                                </Field>
                                            </Grid>
                                            <LoadingButton type="submit"
                                                variant="contained"
                                                size="large"
                                                loading={submitting}
                                            >
                                                Submit
                                            </LoadingButton>
                                        </Grid>
                                    </form>
                                )}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Grid container spacing={.5}>
                                <Grid size={12}>
                                    <Typography sx={{ fontSize: "x-small" }}><strong>Privacy Assurance:</strong> futuresTHRIVE will not sell any personal information provided. The information collected will only be used for the purposes outlined in this program and to improve services. Full privacy policy details can be found at <a href="www.futuresTHRIVE.com">www.futuresTHRIVE.com.</a></Typography>
                                </Grid>
                            </Grid>
                            <Grid container spacing={.5}>
                                <Grid size={12}>
                                    <Typography sx={{ fontSize: "x-small" }}>
                                        <strong>Disclaimer:</strong> futuresTHRIVE™ tScreen™ and TweenScreen™ are mental health screening tools and do not diagnose any specific conditions. The information provided should be discussed with a licensed mental health professional, and is not a substitute for professional diagnosis or treatment.</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <ParentalConsentConfirmModal
                        consentStatus={consentStatus}
                        studentName={studentDetails?.studentName}
                        submitting={submitting}
                        openModal={openParentModal}
                        closeModal={() => setOpenModal(false)}
                        onCancel={() => setOpenModal(false)}
                        onConfirm={() => onSubmit(consentStatus)}
                    />
                </DefaultContainer>
            </div>

        </Fade>
    )
}

type ErrorMessageCodeType = 'NOT_AUTHORIZED' | 'FORM_COMPLETED' | 'LINK_EXPIRED' | null | undefined

function ErrorComponent({ code }: { code: ErrorMessageCodeType }) {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <DefaultContainer style={{ height: "300px" }}>
                <Grid container spacing={2} sx={{ padding: ".5rem", textAlign: "center" }}>
                    <Grid size={12} style={{ marginTop: "2px", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
                        <div style={{
                            width: "300px", height: "175px", objectFit: "cover", background: `url(${process.env.PUBLIC_URL}/assets/images/logos/FT_logo_1.png)`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                        }}></div>
                    </Grid>
                    <Grid size={12}>
                        <ErrorMessage code={code} />
                    </Grid>
                </Grid>
            </DefaultContainer>
        </div>
    )
}
function ErrorMessage({ code }: { code: ErrorMessageCodeType }) {
    switch (code) {
        case 'NOT_AUTHORIZED':
            return (
                <>
                    <strong>Error: </strong> Either students details are missing or do not match student stored.Please contact your support representative for further assistance.
                </>)
        case 'FORM_COMPLETED':
            return (
                <>
                    <Typography>This form has already been completed.
                    </Typography></>
            )
        case 'LINK_EXPIRED':
            return (
                <Typography>This link has expired, please reach out to you school/pediatrician/mental health provider</Typography>
            )
        default:
            return (
                <Typography><strong>Error: </strong> Either the application is unavailable at this time or the link has already been used. Please contact your support representative for further assistance.</Typography>
            )
    }
}
type FormCompleteType = 'JUST_SUBMITTED' | 'DONE_ALREADY'
function FormAlreadyCompleted({ type }: { type: FormCompleteType }) {
    const message = type === "JUST_SUBMITTED" ? "Thank you. You can now close this window. Make sure to check your email" : "This form has been filled out already. You should have been sent a copy to the same email, you accessed this link from. If you do not please reach out to your support representative for further assistance."
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <DefaultContainer style={{
                backgroundSize: "cover", backgroundPosition: "center",
                height: "500px",
                margin: ".5rem",
            }}>
                <Grid container spacing={1} sx={{ padding: ".5rem", textAlign: "center" }}>
                    <Grid size={12} style={{ marginTop: "2px", display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
                        <div style={{
                            width: "300px",
                            height: "200px", objectFit: "cover", background: `url(${process.env.PUBLIC_URL}/assets/images/logos/FT_logo_1.png)`,
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                        }}></div>
                    </Grid>
                    <Grid size={12}>
                        <Typography>{message}</Typography>
                    </Grid>
                </Grid>
            </DefaultContainer>
        </div>
    )
}

export default ParentalConsent